import { Icon, Button } from '@evertrue/et-components';
import PropTypes from 'prop-types';
import { useGlobalDrawerProvider } from 'components/drawer/context/global-drawer-context';
import { trackOutreachAction } from 'apps/outreach/utils/utils';

const EmailEmptyState = ({ type = 'draft', isFilterApplied = false }) => {
  const { addDrawer } = useGlobalDrawerProvider();

  let title = "You can start a draft and send it when you're ready";
  let subtitle =
    "Get interrupted? Queuing up your outreach for later? No matter the reason, your work is ready when you are - just close out of the email composer and you'll find all your drafts saved here for a final polish";
  let iconName = 'email-drawer-icon';

  if (type === 'scheduled') {
    title = 'Compose your email now, send later';
    subtitle =
      'Find your scheduled emails here. Set them up in advance, refine anytime, and let them send automatically at the right moment.';
    iconName = 'scheduled-send';
  }

  if (type == 'sent') {
    title = 'No sent emails yet';
    subtitle =
      'Your sent emails will appear here. Once you send an email, you can find it here to review or follow up when needed.';
    iconName = 'sent';
  }

  if (isFilterApplied) {
    title = `You don't have any ${type} emails matching your search criteria`;
    subtitle = 'Try adjusting your filters or changing your search combination.';
    iconName = type === 'sent' ? 'sent' : type === 'draft' ? 'email-drawer-icon' : 'scheduled-send';
  }

  return (
    <div className="email-empty-state">
      <Icon icon={iconName} iconKit="gt2" className="email-empty-state__icon" />
      <h2 className="email-empty-state__title">{title}</h2>
      <p className="email-empty-state__subtitle">{subtitle}</p>
      {!(type === 'sent' || isFilterApplied) && (
        <Button
          size="large"
          type="secondary"
          onClick={() => {
            trackOutreachAction('open_emailer');
            addDrawer('emailer', {
              drawerTitle: 'New Message',
            });
          }}
        >
          Compose Email
        </Button>
      )}
    </div>
  );
};

EmailEmptyState.propTypes = {
  type: PropTypes.string,
  isFilterApplied: PropTypes.bool,
};

export default EmailEmptyState;
